import React from 'react';

import SidebarMenu, { type SidebarMenuItem } from './sidebar-menu';

const items: SidebarMenuItem[] = [
  { key: 'products', to: '/downloader/products', label: 'Products' },
  {
    key: 'warehouse-categories',
    to: '/downloader/warehouse-categories',
    label: 'Warehouse categories',
  },
  {
    key: 'warehouse-properties',
    to: '/downloader/warehouse-properties',
    label: 'Warehouse properties',
  },
  {
    key: 'warehouse-products',
    to: '/downloader/warehouse-products',
    label: 'Warehouse products',
  },
];

function SidebarDownloaderComponent(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarDownloaderComponent;
